<div class="status-bonus-panel" *ngIf="open && bonus as b">
  <div class="status-bonus-panel__title">
    <ion-icon name="star" class="status-bonus-panel__star"></ion-icon>
    <span>{{
      'movacarpro_status_bonus_panel_title'
        | translate: { status: (b.statusLabelKey | translate) }
    }}</span>
  </div>

  <div class="status-bonus-panel__row">
    <span>{{ 'movacarpro_status_bonus_per_ride' | translate }}</span>
    <span class="status-bonus-panel__value">{{
      'movacarpro_status_bonus_of_ride_price'
        | translate: { percent: b.percentLabel }
    }}</span>
  </div>

  <div class="status-bonus-panel__row">
    <span>{{
      'movacarpro_status_bonus_example_at'
        | translate
          : {
              price:
                examplePriceInEur
                | currency: 'EUR' : 'symbol' : undefined : languageService.activeLanguage.key
            }
    }}</span>
    <span class="status-bonus-panel__value"
      >+{{
        b.amount
          | currency: 'EUR' : 'symbol' : undefined : languageService.activeLanguage.key
      }}</span
    >
  </div>

  <div class="status-bonus-panel__notice">
    <ion-icon name="information-circle-outline"></ion-icon>
    <span>{{ 'movacarpro_status_bonus_payout_notice' | translate }}</span>
  </div>
</div>
